import { AbstractControl, ValidatorFn } from '@angular/forms';

const CHANNEL_MAPPED_ID_MAX_LENGTH = 36;

export const channelMappedIdValidator = (): ValidatorFn => {
    return (control: AbstractControl) => {
        if (!control.value) {
            return null;
        }

        let value = control.value;
        if (typeof control.value !== 'string') {
            value = (value ?? '').toString();
        }

        if (value.length > CHANNEL_MAPPED_ID_MAX_LENGTH) {
            return {
                maxLength: {
                    requiredLength: CHANNEL_MAPPED_ID_MAX_LENGTH,
                },
            };
        }

        // TODO: there are lots of channel mapped IDs on PROD that have various special characters (@, ?, -, etc.)
        // changing this validator would force users to change the existing IDs as well, so we will only have the max length requirement for now

        // const channelMappedIdPatternMatch = /^[A-Za-z\d]{0,36}$/.test(control.value);
        // if (!channelMappedIdPatternMatch) {
        //     return {
        //         channelMappedIdPatternMismatch: true,
        //     };
        // }

        return null;
    };
};
